module.exports = __webpack_public_path__ + "img/Heck.da935ee3.jpg";